import {gql} from '@apollo/client'

export const LOGIN = gql`
  mutation TokenAuth($email: String!, $password: String!) {
    tokenAuth(email: $email, password: $password) {
      token
      payload
      refreshToken
      refreshExpiresIn
      rol
      permissions
      name
    }
  }
`
export const VERIFY_TOKEN = gql`
  mutation ($token: String) {
    verifyToken(token: $token) {
      payload
    }
  }
`
